<template>
  <div
    :class="{
      'common-list-status': true,
      'loading-end': loadingEnd
    }"
  >
    <icon name="logo" class="icon" :style="{ color: customColor }"></icon>
    <div class="text" :style="{ color: customColor }">{{ showText }}</div>
  </div>
</template>

<script>
import icon from 'component/common/icon'
export default {
  components: {
    icon
  },
  props: {
    loadingEnd: {
      type: Boolean
    },
    showText: {
      type: String,
      default: `“壹心理咨询，让改变发生”`
    },
    customColor: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
$h: 36.8px;
$iconW: 54px;
$textW: 325px;
$space: 16px;
.common-list-status {
  height: $h;
  margin-top: 14px;
  margin-bottom: 55px;
  position: relative;
  .icon,
  .text {
    position: absolute;
    left: 50%;
    top: 0;
    transition: transform 0.5s, opacity 0.5s;
  }
  .icon {
    top: 50%;
    font-size: 58px;
    width: 54px;
    margin-left: $iconW / -2;
    color: #d7dae1;
    transform: translate3d(-$textW / 2 - $space, -50%, 0);
  }
  .text {
    font-size: 26px;
    color: #dcdfe5;
    line-height: $h;
    // width: $textW;
    margin-left: $textW / -2;
    // transition-delay: 0.2s;
    transform: translate3d($iconW / 2, 0, 0);
    opacity: 1;
  }
  &.loading-end {
    .icon {
      transform: translate3d(0, -50%, 0);
    }
    .text {
      transform: translate3d(0, 0, 0);
      opacity: 0;
    }
  }
}
</style>
